import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';

import { DebounceInput } from 'react-debounce-input'
import Select from 'react-select'
import { Modal } from 'react-bootstrap';

import { GET } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'
import PriceTag60x40 from './PriceTag60x40'
import PriceTag60x30 from './PriceTag60x30'
import PriceTag40x30 from './PriceTag40x30'
import PriceTag30x20 from './PriceTag30x20'
import { BarcodeModeContext, BarcodeMaxMmContext } from './TagBarcode'
import TagConstructor from './constructor/TagConstructor'
import useDidMountEffect from 'pages/parts/useDidMountEffect';


function PriceTags() {
	const { t } = useTranslation();
	const dispatch = useDispatch()

	const reduxProductList = useSelector(state => state.transferData.documentInProductList)
	// "Sozlamalar" toggle'lari localStorage'da (Redux settings) saqlanadi -- sahifadan
	// chiqib qaytganda ham eslab qolinsin. Eski foydalanuvchida bo'lmasligi mumkin.
	const savedOptions = useSelector(state => state.settings.priceTagOptions) || {}

	const printRef = useRef(null);

	// 'templates' -- eski tayyor shablonlar, 'constructor' -- qo'lda joylashtirish
	const [activeTab, setActiveTab] = useState('templates')
	const [settingsModal, setSettingsModal] = useState(false)
	const [activatePrice, setActivatePrice] = useState(savedOptions.activatePrice ?? 0)
	const [activeA4, setActiveA4] = useState(savedOptions.activeA4 ?? false)
	const [activeDate, setActiveDate] = useState(savedOptions.activeDate ?? false)
	const [activeOldPrice, setActiveOldPrice] = useState(savedOptions.activeOldPrice ?? false)
	// Shtrix-kod ko'rinishi: 'auto' (haqiqiy EAN-13/EAN-8 -> o'z formati, aks holda
	// CODE128) yoki 'code128' (hammasi bir xil CODE128). Foydalanuvchi tanlaydi.
	const [barcodeMode, setBarcodeMode] = useState(savedOptions.barcodeMode ?? 'auto')
	const [barcode, setBarcode] = useState(false)

	const [poses, setPoses] = useState([])
	const [posId, setPosId] = useState(null)

	// const [activateBankPrice, setActivateBankPrice] = useState(false)
	const [selectedPriceTag, setSelectedPriceTag] = useState({
		'priceTag60x40_1': false,
		'priceTag60x40_2': false,
		'priceTag60x40_3': false,
		'priceTag60x40_4': false,
		'priceTag60x40_5': false,
		'priceTag60x40_6': false,
		'priceTag60x40_7': false,
		'priceTag60x40_8': false,
		'priceTag60x40_9': false,
		'priceTag60x30_1': false,
		'priceTag60x30_2': false,
		'priceTag60x30_3': false,
		'priceTag60x30_4': false,
		'priceTag60x30_5': false,
		'priceTag60x30_6': false,
		'priceTag60x30_7': false,
		'priceTag60x30_8': false,
		'priceTag60x30_9': false,
		'priceTag60x30_10': false,
		'priceTag60x30_11': false,
		'priceTag40x30_1': false,
		'priceTag40x30_2': false,
		'priceTag40x30_3': false,
		'priceTag30x20_1': false,
		'priceTag30x20_2': false,
		'priceTag30x20_3': false,
		'priceTag30x20_4': false,
	})
	const [products, setProducts] = useState([])
	const [printProducts, setPrintProducts] = useState([])
	const [printSignal, setPrintSignal] = useState(0)
	const [searchData, setSearchData] = useState([])
	const [search, setSearch] = useState('')
	const [data, setData] = useState({
		productName: 'ВАФЛИ СЛАДОНЕЖ С ШОКОЛАДНЫМИ ШОКОЛАДНЫМИ',
		posName: 'Pos market',
		salePrice: '175000',
		actionPrice: '175000',
		quantity: 1,
		currencyId: 1,
		currencyName: "So'm",
		barcode: "6921734977878",
		uomName: "шт",
		productImageUrl: ""
	});
	const [cashbox, setCashbox] = useState({
		cashboxId: 11,
		defaultCurrency: 'So`m',
		hidePriceIn: true,
		loyaltyApi: "",
		posId: 15,
		posName: "idokon test",
		saleMinus: false,
	})
	const [allQuantity, setAllQuantity] = useState('')

	async function searchProduct(value) {
		setSearch(value)
		if (value.length > 0) {
			const response = await GET('/services/web/api/product-price-tags-list', { posId: posId, name: value, barcode: barcode, })
			if (response) {
				if (response.length === 0) {
					toast.error(t('nothing_found'))
				}
				if (response.length === 1) {
					addToList(response[0])
					setSearch('')
				}
				if (response.length > 1) {
					setSearchData(response)
				}
			}
		}
	}

	const addToList = (product, fromList = false) => {
		if (fromList) {
			var searchDataCopy = [...searchData]
			var newArray = searchDataCopy.filter(e => e.barcode !== product.barcode)
			setSearchData(newArray)
			if (newArray.length === 0) {
				setSearch('')
			}
		} else {
			setSearch('')
		}
		product.salePriceOriginal = product.salePrice
		if (activeOldPrice) {
			product.actionPrice = product.oldSalePrice
		}
		if (activatePrice === 0) {
			product.salePrice = product.salePriceOriginal
		} else if (activatePrice === 1) {
			product.salePrice = product.wholesalePrice;
		} else if (activatePrice === 2) {
			product.salePrice = product.bankPrice;
		}
		var found = false
		if (products.length) {
			for (let i = 0; i < products.length; i++) {
				if (products[i].barcode === product.barcode) {
					products[i].quantity += 1
					found = true
				}
			}

			if (!found) {
				product.quantity = 1
				setProducts([...products, product]);
			}
		} else {
			product.quantity = 1
			setProducts([...products, product]);
		}
	}

	const selectProduct = (product) => {
		for (let i = 0; i < products.length; i++) {
			if (product.id === products[i]['id']) {
				products[i]['selected'] = true
			} else {
				products[i]['selected'] = false
			}
		}
		setData(product)
	}

	const deleteItem = (index) => {
		var productsCopy = [...products]
		productsCopy.splice(index, 1)
		setProducts(productsCopy)
	}

	const handlePrint = useReactToPrint({
		content: () => printRef.current
	});

	const selectPriceTag = (selectedKey) => {
		var selectedPriceTagCopy = { ...selectedPriceTag }
		for (const [key] of Object.entries(selectedPriceTagCopy)) {
			if (key === selectedKey) {
				selectedPriceTagCopy[key] = true
			} else {
				selectedPriceTagCopy[key] = false
			}
		}
		setSelectedPriceTag(selectedPriceTagCopy)
	}

	function handleProductChange(event, i) {
		const { name, value } = event.target
		// Har bir mahsulotni yangi nusxa qilib o'zgartiramiz (joyida emas) -- shunda
		// havola o'zgaradi va preview ishonchli qayta chiziladi.
		const productsCopy = products.map((p, idx) => (idx === i ? { ...p, [name]: value } : p))
		setProducts(productsCopy)

		// Preview (data) aynan shu mahsulotni ko'rsatayotgan bo'lsa, uni ham yangilaymiz.
		// Aks holda tahrirlangan chegirma/narx preview'da ko'rinmaydi (ilgari data
		// products[i] bilan bir xil obyekt bo'lgani uchun joyida o'zgarardi, lekin
		// setData chaqirilmagani sabab preview qayta chizilmasdi).
		const edited = productsCopy[i]
		if (data && (data.barcode === edited.barcode || (data.id != null && data.id === edited.id))) {
			setData(edited)
		}
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			setPoses(response)
			setPosId(response[0]['id'])
			if (response[0]['currency'] === 1) {
				setCashbox({ ...cashbox, 'defaultCurrency': 'So`m' })
			}
			if (response[0]['currency'] === 2) {
				setCashbox({ ...cashbox, 'defaultCurrency': 'USD' })
			}
		}
	}

	useEffect(() => {
		if (reduxProductList.length > 0) {
			console.log(reduxProductList);
			setProducts(reduxProductList)
			dispatch({ type: 'SET_DOCUMENT_IN_PRODUCT_LIST', payload: [] })
		}
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		var productsCopy = [...products]
		var prepareProducts = []
		for (let i = 0; i < productsCopy.length; i++) {
			for (let j = 0; j < productsCopy[i]['quantity']; j++) {
				prepareProducts.push(productsCopy[i])
			}
		}
		setPrintProducts(prepareProducts)
	}, [products])

	useEffect(() => {
		if (search.length === 0) {
			setSearchData([])
		}
	}, [search])

	useDidMountEffect(() => {
		var productsCopy = [...products]
		for (let i = 0; i < productsCopy.length; i++) {
			if (activeOldPrice) {
				productsCopy[i].actionPrice = productsCopy[i].oldSalePrice
			} else {
				productsCopy[i].actionPrice = '';
			}
		}
		setProducts(productsCopy)
	}, [activeOldPrice]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		var productsCopy = [...products]
		for (let i = 0; i < productsCopy.length; i++) {
			if (activatePrice === 0) {
				productsCopy[i].salePrice = productsCopy[i].salePriceOriginal
			} else if (activatePrice === 1) {
				productsCopy[i].salePrice = productsCopy[i].wholesalePrice;
			} else if (activatePrice === 2) {
				productsCopy[i].salePrice = productsCopy[i].bankPrice;
			}
		}
		setProducts(productsCopy)
	}, [activatePrice]) // eslint-disable-line react-hooks/exhaustive-deps

	// Toggle'lar o'zgarganda Redux'ga (va u orqali localStorage'ga) saqlaymiz.
	useEffect(() => {
		dispatch({
			type: 'SET_PRICE_TAG_OPTIONS',
			payload: { activatePrice, activeA4, activeDate, activeOldPrice, barcodeMode },
		})
	}, [activatePrice, activeA4, activeDate, activeOldPrice, barcodeMode]) // eslint-disable-line react-hooks/exhaustive-deps


	const searchRef = useRef(null);
	useEffect(() => {
		// Konstruktorda tugmalar elementni surish/o'chirish uchun kerak --
		// fokusni qidiruvga o'g'irlab ketmaymiz.
		if (activeTab === 'constructor') return

		const handleKeyPress = (e) => {
			const active = document.activeElement;
			const isEditable =
				active &&
				(active.tagName === "INPUT" || active.tagName === "TEXTAREA") &&
				!active.disabled &&
				!active.readOnly;

			if (!isEditable && searchRef.current) {
				// Agar hech qanday input fokusda bo'lmasa
				searchRef.current.focus();
			}
		};

		document.addEventListener("keydown", handleKeyPress);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
		};
	}, [activeTab]);

	return (
		<div className="pt-40">

			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('PRICE_TAGS')}
				</h4>
			</div>

			<div className="card mb-2">
				<div className="card-body">
					<div className="row mb-2">
						<div className="col-md-5 vertical-center">
							<div className="d-flex position-relative">
								<div className="position-relative w-100">
									{searchData.length > 0 ?
										<i className="uil uil-times input-search-icon cursor"
											onClick={() => setSearch('')}></i>
										:
										<i className={'uil uil-qrcode-scan search-barcode ' + (barcode && 'text-primary')} onClick={() => setBarcode(!barcode)}></i>
									}
									<DebounceInput
										inputRef={searchRef}
										value={search}
										type="text"
										className="form-control"
										placeholder={t('SEARCH') + '...'}
										minLength={1}
										debounceTimeout={1000}
										onChange={(e) => searchProduct(e.target.value)}
									/>
								</div>

								{searchData.length > 0 &&
									<span className="dropdown-search-menu">
										<div className="dropdown-menu-list">
											<div className="table-responsive p-2 mb-0">
												<table className="table">
													<thead>
														<tr>
															<th>{t('NAME_OF_PRODUCT')}</th>
															<th className="text-center">{t('BARCODE')}</th>
															<th className="text-center">{t('ACTION')}</th>
														</tr>
													</thead>
													<tbody>
														{searchData.map((item, index) => (
															<tr key={index}>
																<td>{item.productName}</td>
																<td className="text-center">{item.barcode}</td>
																<td className="d-flex justify-content-center">
																	<div className="table-action-button table-action-primary-button" onClick={() => addToList(item, true)}>
																		<i className="uil uil-plus"></i>
																	</div>
																</td>
															</tr>
														))
														}
													</tbody>
												</table>
											</div>
										</div>
									</span>
								}
							</div>
						</div>
						<div className="col-md-5 vertical-center">
							<Select
								options={poses}
								value={poses.find(option => option.id === posId)}
								onChange={(option) => {
									setPosId(option.id)
									if (option.currency === 1) {
										setCashbox({ ...cashbox, 'defaultCurrency': 'So`m' })
									}
									if (option.currency === 2) {
										setCashbox({ ...cashbox, 'defaultCurrency': 'USD' })
									}
								}
								}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="col-md-2 vertical-center">
							<button className="btn btn-primary" onClick={() => setSettingsModal(true)}>
								{t('SETTINGS')}
							</button>
						</div>
					</div>

					{/* TABLE */}
					<div className="table-responsive h-table-price-tags">
						<table className="table fz14">
							<thead>
								<tr>
									<th>{t('NAME_OF_PRODUCT')}</th>
									<th className="text-center">
										<input
											type="number"
											className="auto-width-input"
											placeholder={t('QUANTITY')}
											value={allQuantity}
											onChange={e => {
												setAllQuantity(e.target.value)
												if (e.target.value !== '' && !isNaN(e.target.value)) {
													const val = Number(e.target.value)
													const updated = products.map(p => ({ ...p, quantity: val }))
													setProducts(updated)
												}
											}}
										/>
									</th>
									<th className="text-center">{t('BARCODE')}</th>
									<th className="text-center">{t('PRICE')}</th>
									<th className="text-center">{activeOldPrice ? t('OLD_PRICE') : t('DISCOUNT')}</th>
									<th className="text-center">{t('ACTION')}</th>
								</tr>
							</thead>
							<tbody>
								{products.length > 0 ? products.map((product, index) => (
									<tr key={index} className={"cursor " + (product.selected ? "cashbox-table-active" : "cashbox-table-bg-on-hover")}>
										<td onClick={() => selectProduct(product)}>{index + 1}. {product.productName}</td>
										<td className="text-center">
											<div className="d-flex justify-content-center">
												<input type="number" className="auto-width-input"
													name="quantity"
													value={product.quantity}
													onChange={(e) => handleProductChange(e, index)} />
											</div>
										</td>
										<td className="text-center" onClick={() => selectProduct(product)}>{product.barcode}</td>
										<td className="text-center" onClick={() => selectProduct(product)}>
											{activatePrice === 0 && formatMoney(product.salePrice)}
											{activatePrice === 1 && formatMoney(product.wholesalePrice)}
											{activatePrice === 2 && formatMoney(product.bankPrice)}
										</td>
										<td className="text-center">
											<div className="d-flex justify-content-center">
												<input type="number" className="auto-width-input"
													name="actionPrice"
													value={product.actionPrice}
													onChange={(e) => handleProductChange(e, index)} />
											</div>
										</td>
										<td className="d-flex justify-content-center">
											<div className="table-action-button table-action-danger-button"
												onClick={() => deleteItem(index)}>
												<i className="uil uil-times"></i>
											</div>
										</td>
									</tr>
								)) : <tr>
									<td colSpan="10" className="text-center">{t('NO_DATA')}</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
					{/* TABLE */}
				</div>
			</div>

			{/* TABS: tayyor shablonlar / qo'lda joylashtirish */}
			<ul className="nav nav-tabs mb-2">
				<li className="nav-item">
					<button type="button"
						className={'nav-link ' + (activeTab === 'templates' ? 'active' : '')}
						onClick={() => setActiveTab('templates')}>
						{t('TEMPLATES')}
					</button>
				</li>
				<li className="nav-item">
					<button type="button"
						className={'nav-link ' + (activeTab === 'constructor' ? 'active' : '')}
						onClick={() => setActiveTab('constructor')}>
						{t('CONSTRUCTOR')}
					</button>
				</li>
			</ul>

			{activeTab === 'constructor' &&
				<div className="card position-relative">
					<div className="card-body">
						<TagConstructor
							printProducts={printProducts}
							sampleProduct={data}
							cashbox={cashbox}
						/>
					</div>
				</div>
			}

			{/* PRICE TAG EXAMPLES */}
			{activeTab === 'templates' &&
			<div className="card h-table-price-tags2 position-relative">
				<div className="card-body">
					<div className={"h-table-price-tags3 " + (activeDate ? '' : 'hide-date')}>
						<BarcodeModeContext.Provider value={barcodeMode}>
						<h6 className="mb-2">{t('price_tag')} (60х40 мм)</h6>
						<BarcodeMaxMmContext.Provider value={38}>
							<PriceTag60x40
							cashbox={cashbox}
							data={data}
							selectedPriceTag={selectedPriceTag}
							selectPriceTag={selectPriceTag}
							printProducts={printProducts}
							printRef={printRef}
							printSignal={printSignal}
							a4={activeA4}
							activeDate={activeDate}
						>
						</PriceTag60x40>
							</BarcodeMaxMmContext.Provider>
						<h6 className="mb-2">{t('price_tag')} (60х30 мм)</h6>
						<BarcodeMaxMmContext.Provider value={38}>
							<PriceTag60x30
							cashbox={cashbox}
							data={data}
							selectedPriceTag={selectedPriceTag}
							selectPriceTag={selectPriceTag}
							printProducts={printProducts}
							printRef={printRef}
							activatePrice={activatePrice}
							a4={activeA4}
							activeDate={activeDate}
						>
						</PriceTag60x30>
							</BarcodeMaxMmContext.Provider>
						<h6 className="mb-2">{t('price_tag')} (40x30 мм)</h6>
						<BarcodeMaxMmContext.Provider value={30}>
							<PriceTag40x30
							cashbox={cashbox}
							data={data}
							selectedPriceTag={selectedPriceTag}
							selectPriceTag={selectPriceTag}
							printProducts={printProducts}
							printRef={printRef}
							activatePrice={activatePrice}
							a4={activeA4}
							activeDate={activeDate}
						>
						</PriceTag40x30>
							</BarcodeMaxMmContext.Provider>
						<h6 className="mb-2">{t('price_tag')} (30x20 мм)</h6>
						<BarcodeMaxMmContext.Provider value={27}>
							<PriceTag30x20
							cashbox={cashbox}
							data={data}
							selectedPriceTag={selectedPriceTag}
							selectPriceTag={selectPriceTag}
							printProducts={printProducts}
							printRef={printRef}
							activatePrice={activatePrice}
							setPrintProducts={setPrintProducts}
							a4={activeA4}
							activeDate={activeDate}
						>
						</PriceTag30x20>
							</BarcodeMaxMmContext.Provider>
						</BarcodeModeContext.Provider>
					</div>
					<div className="printing">
						<button type="button" className="btn btn-primary w-25 me-2" disabled={!products.length} onClick={() => {
							setPrintSignal(s => s + 1)
							handlePrint()
						}}>
							{t('print')}
						</button>
					</div>
				</div>
			</div>
			}

			{/* MODAL SETTINGS */}
			<Modal show={settingsModal} animation={false} size="sm" centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setSettingsModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SETTINGS')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('WHOLESALE_PRICE')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" checked={activatePrice === 1}
								onChange={(e) => setActivatePrice(e.target.checked ? 1 : 0)} />
						</div>
					</div>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('BANK_PRICE')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" checked={activatePrice === 2}
								onChange={(e) => setActivatePrice(e.target.checked ? 2 : 0)} />
						</div>
					</div>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('A4 бумага')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" checked={activeA4}
								onChange={(e) => setActiveA4(e.target.checked)} />
						</div>
					</div>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('DATE')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" checked={activeDate}
								onChange={(e) => setActiveDate(e.target.checked)} />
						</div>
					</div>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('OLD_PRICE')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" checked={activeOldPrice}
								onChange={(e) => setActiveOldPrice(e.target.checked)} />
						</div>
					</div>
					<div className="d-between mb-2">
						<p className="fw-600 vertical-center">{t('BARCODE_STYLE')}</p>
						<select className="form-select w-auto" value={barcodeMode}
							onChange={(e) => setBarcodeMode(e.target.value)}>
							<option value="auto">{t('BARCODE_AUTO')}</option>
							<option value="code128">CODE128</option>
							<option value="CODE39">CODE39</option>
							<option value="EAN13">EAN-13</option>
							<option value="EAN8">EAN-8</option>
							<option value="UPC">UPC-A</option>
							<option value="ITF">ITF (2/5)</option>
							<option value="ITF14">ITF-14</option>
							<option value="codabar">Codabar</option>
							<option value="MSI">MSI</option>
							<option value="pharmacode">Pharmacode</option>
						</select>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL SETTINGS */}
		</div>
	)
}

export default PriceTags
